import { Schema } from "effect";
import { SurfaceSchema } from "./app-context";
import { ProjectIdSchema, UserIdSchema, WorkspaceIdSchema } from "./ids";
import { PapersFlowBoundaryParseOptions, toPapersFlowStandardSchema } from "./standard";
import { PermissionSchema } from "./workspace";

export const McpPrincipalSchema = Schema.Struct({
  actorId: UserIdSchema,
  workspaceId: WorkspaceIdSchema,
  permissions: Schema.Array(PermissionSchema).check(Schema.isMaxLength(64)),
});

export const GetWorkspaceContextInputV1Schema = Schema.Struct({
  projectId: Schema.optionalKey(ProjectIdSchema),
});

export const GetWorkspaceContextOutputV1Schema = Schema.Struct({
  version: Schema.Literal("papersflow.mcp.workspace-context/v1"),
  actorId: UserIdSchema,
  workspaceId: WorkspaceIdSchema,
  projectId: Schema.optionalKey(ProjectIdSchema),
  permissions: Schema.Array(PermissionSchema).check(Schema.isMaxLength(64)),
});

export const ListProductSurfacesInputV1Schema = Schema.Struct({});
export const ListProductSurfacesOutputV1Schema = Schema.Struct({
  version: Schema.Literal("papersflow.mcp.product-surfaces/v1"),
  surfaces: Schema.Array(
    Schema.Struct({
      surface: SurfaceSchema,
      contextRole: Schema.String.check(Schema.isMinLength(1), Schema.isMaxLength(240)),
    }),
  ).check(Schema.isMinLength(2), Schema.isMaxLength(2)),
});

export const GetWorkspaceContextInputV1StandardSchema = toPapersFlowStandardSchema(
  GetWorkspaceContextInputV1Schema,
);
export const GetWorkspaceContextOutputV1StandardSchema = toPapersFlowStandardSchema(
  GetWorkspaceContextOutputV1Schema,
);
export const ListProductSurfacesInputV1StandardSchema = toPapersFlowStandardSchema(
  ListProductSurfacesInputV1Schema,
);
export const ListProductSurfacesOutputV1StandardSchema = toPapersFlowStandardSchema(
  ListProductSurfacesOutputV1Schema,
);

export const decodeMcpPrincipal = Schema.decodeUnknownSync(
  McpPrincipalSchema,
  PapersFlowBoundaryParseOptions,
);
export const decodeGetWorkspaceContextOutputV1 = Schema.decodeSync(
  GetWorkspaceContextOutputV1Schema,
  PapersFlowBoundaryParseOptions,
);
export const decodeListProductSurfacesOutputV1 = Schema.decodeSync(
  ListProductSurfacesOutputV1Schema,
  PapersFlowBoundaryParseOptions,
);

export type McpPrincipal = typeof McpPrincipalSchema.Type;
export type GetWorkspaceContextInputV1 = typeof GetWorkspaceContextInputV1Schema.Type;
export type GetWorkspaceContextOutputV1 = typeof GetWorkspaceContextOutputV1Schema.Type;
export type ListProductSurfacesOutputV1 = typeof ListProductSurfacesOutputV1Schema.Type;
